import { jsx as e, jsxs as y } from "react/jsx-runtime";
import s from "classnames";
import { noop as Y } from "lodash/fp";
/* empty css             */
import { TextPrimitive as q } from "./index.es799.js";
import { CellAdditionalInfoWrapper as z } from "./index.es731.js";
import { useBaseHeaderEGridSetup as J } from "./index.es5659.js";
import { useBaseHeaderFilterState as Q } from "./index.es5660.js";
import { useMenuWidth as V } from "./index.es5661.js";
import { useBaseHeaderSort as X } from "./index.es5662.js";
import { Dropdown as Z } from "./index.es72.js";
import { SimpleTooltip as c } from "./index.es127.js";
import { BasicDropdownMenu as I } from "./index.es73.js";
import { UtilityMoreIcon as ee } from "./index.es457.js";
import { mergeRefs as B } from "./index.es551.js";
const te = "default-base-header", M = "Grid Column Header", be = ({
  testId: t = te,
  enableSorting: n,
  enableFilterButton: d,
  displayName: p,
  column: i,
  children: f,
  menuItems: o,
  eGridHeader: S,
  api: D,
  wrapHeaderText: R,
  additionalInfo: T,
  setSort: A,
  showFilter: E = Y
}) => {
  const a = f || p || M, w = a === M, {
    moreMenuRef: F,
    filterButtonRef: P,
    sortButtonRef: k
  } = J(
    S,
    d,
    n,
    o,
    a
  ), { filterButtonRef: H, onFilterButton: O, onFilterKeydown: _ } = Q(
    D,
    i,
    E
  ), { maxWidth: $, isMenuOpen: m, setIsMenuOpen: u } = V(o), {
    ascSort: h,
    descSort: g,
    sortAscRef: L,
    sortDescRef: W,
    sortAnnouncementRef: G,
    sortButtonRef: K,
    sortButtonLabel: b,
    onSortButtonClick: C,
    onSortKeyDown: U
  } = X(i, n, A, a), v = i == null ? void 0 : i.isFilterActive(), j = s(
    "ag-header-icon",
    "ag-header-icon-not-sort",
    "menuContainer",
    { "ag-column-menu-active": m }
  );
  let l;
  return typeof a == "string" ? l = /* @__PURE__ */ e(
    q,
    {
      "data-ref": "eText",
      testId: t + "-cell-text",
      isEllipsis: !R,
      type: "body",
      className: "ag-header-cell-text",
      children: a
    }
  ) : l = /* @__PURE__ */ e(
    "span",
    {
      "data-ref": "eText",
      className: s("ag-header-cell-text", "custom-cell-wrapper"),
      "data-testid": t + "-cell-text",
      children: a
    }
  ), /* @__PURE__ */ y("div", { className: "ag-cell-label-container", "data-testid": t, children: [
    /* @__PURE__ */ e(
      "div",
      {
        ref: G,
        "aria-live": "polite",
        "aria-atomic": "true",
        className: "sr-only",
        style: {
          position: "absolute",
          left: "-10000px",
          width: "1px",
          height: "1px",
          overflow: "hidden"
        }
      }
    ),
    !!(o != null && o.length) && /* @__PURE__ */ e(c, { appendToParent: !0, title: "More Actions", children: /* @__PURE__ */ e(
      Z,
      {
        appendToParent: !0,
        trigger: /* @__PURE__ */ e(
          "button",
          {
            className: j,
            ref: F,
            "data-ref": "eMoreMenu",
            "aria-label": `More actions for ${a}`,
            children: /* @__PURE__ */ e(ee, {})
          }
        ),
        testId: `${f || p}-column-menu`,
        align: "start",
        onClick: (r) => r.stopPropagation(),
        menuWidth: $,
        open: m,
        onOpenChange: u,
        alignOffset: -4,
        closeOnSelection: !0,
        children: /* @__PURE__ */ e(
          I,
          {
            items: o.map((r) => ({
              ...r,
              onClick: (N) => {
                var x;
                (x = r.onClick) == null || x.call(r, N), u(!1), N.stopPropagation();
              }
            }))
          }
        )
      }
    ) }),
    d && /* @__PURE__ */ e(c, { appendToParent: !0, title: "Filter Column", children: /* @__PURE__ */ e(
      "button",
      {
        "data-ref": "eFilterButton",
        className: `ag-header-icon ag-header-cell-filter-button ${v ? "ag-filter-active" : ""} ag-header-icon-not-sort filter-button-focus-visible`,
        "aria-label": `Filter ${a} column`,
        "aria-pressed": v,
        ref: B(H, P),
        "data-testid": t + "-filter-button",
        onClick: O,
        onKeyDown: _,
        children: /* @__PURE__ */ e("span", { className: "ag-icon ag-icon-filter", role: "presentation" })
      }
    ) }),
    n && /* @__PURE__ */ e(c, { appendToParent: !0, title: b, children: /* @__PURE__ */ y(
      "button",
      {
        ref: B(K, k),
        className: "ag-header-sort-button",
        "aria-label": b,
        onClick: C,
        onKeyDown: U,
        "data-ref": "eSortButton",
        "data-testid": t + "-sort-button",
        children: [
          /* @__PURE__ */ e(
            "span",
            {
              "data-ref": "eSortAsc",
              className: `ag-header-icon ag-header-label-icon ag-sort-ascending-icon ${h === "active" ? "ag-sort-active" : ""}`,
              "aria-hidden": "true",
              style: { display: h === "active" ? "inline" : "none" },
              "data-testid": t + "-cell-sort-asc",
              ref: L,
              children: /* @__PURE__ */ e("span", { className: "ag-icon ag-icon-asc", role: "presentation" })
            }
          ),
          /* @__PURE__ */ e(
            "span",
            {
              "data-ref": "eSortDesc",
              className: `ag-header-icon ag-header-label-icon ag-sort-descending-icon ${g === "active" ? "ag-sort-active" : ""}`,
              "aria-hidden": "true",
              "data-testid": t + "-cell-sort-dsc",
              ref: W,
              style: { display: g === "active" ? "inline" : "none" },
              children: /* @__PURE__ */ e("span", { className: "ag-icon ag-icon-desc", role: "presentation" })
            }
          )
        ]
      }
    ) }),
    /* @__PURE__ */ e(
      "div",
      {
        "data-ref": "eLabel",
        role: "presentation",
        onClick: C,
        className: s("ag-header-cell-label", {
          sortingEnabled: n,
          hideContent: w
        }),
        "data-testid": t + "-cell-label",
        children: /* @__PURE__ */ e(z, { ...T, children: l })
      }
    )
  ] });
};
export {
  be as BaseHeader,
  te as DEFAULT_BASE_HEADER_TESTID
};
//# sourceMappingURL=index.es5578.js.map
